import { useDebounce } from "hooks/useDebounce"
import { useEffect, useRef, useState } from "react"
import { useFormContext } from "react-hook-form"

export function SearchMultiSelectDropdown({useSearchHook, placeholder, label, name}:any) {
  const { watch, setValue } = useFormContext()
  const selected = watch("entities") ?? []

  const [search, setSearch] = useState("")
  const [isOpen, setIsOpen] = useState(false)

  const debouncedSearch = useDebounce(search, 400)
  const { data, isFetching } = useSearchHook(debouncedSearch)

  const selectedIds = new Set(selected.map((e: any) => e.id))
  const containerRef = useRef<HTMLDivElement>(null)

console.log(useSearchHook);
  const handleSelect = (episode: any) => {
    setValue("entities", [...selected, {...episode, type : name}], { shouldDirty: true })
    setSearch("")
    setIsOpen(false) // ✅ CLOSE DROPDOWN
  }

  /** ✅ Close dropdown on outside click */
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const results = data?.results ?? []

  return (
    <div ref={containerRef} className="relative">
      <input
        value={search}
        onChange={e => {
          setSearch(e.target.value)
          setIsOpen(true)
        }}
        onFocus={() => setIsOpen(true)}
        placeholder={placeholder}
        className="w-full border rounded px-3 py-2 dark:bg-slate-700 dark:text-white dark:border-gray-600 dark:focus:border-blue-500 dark:hover:border-blue-500"
      />

      {isOpen && isFetching && (
        <div className="absolute z-20 mt-1 w-full bg-white border rounded px-3 py-2 text-sm text-gray-500">
          Searching...
        </div>
      )}

    {isOpen &&
      !isFetching &&
      debouncedSearch.trim().length > 0 &&
      results.length === 0 && (
        <div className="absolute z-20 mt-1 w-full bg-white border rounded px-3 py-2 text-sm text-gray-500">
          No results found
        </div>
    )}

      {isOpen && results.length > 0 && (
        <div
          className="
            absolute z-20 mt-1 w-full
            bg-white border rounded
            max-h-60 overflow-y-auto
            shadow-lg
          "
        >
          {results.map((ep: any) => {
            const isSelected = selectedIds.has(ep.id)

            return (
              <button
                key={ep.id}
                type="button"
                disabled={isSelected}
                onClick={() => handleSelect(ep)}
                className="
                  flex w-full gap-3 px-3 py-2 text-left
                  hover:bg-gray-100
                  disabled:opacity-50
                  disabled:cursor-not-allowed
                "
              >
                <img
                  src={ep.thumbnail}
                  className="w-8 h-8 rounded object-cover"
                  alt={ep.name}
                />
                <div>
                  <p className="text-sm font-medium">{ep.name}</p>
                  <p className="text-xs text-gray-500">{ep.type}</p>
                </div>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
